import {http} from "Services/Http/HttpClient";
import {DropzoneFile} from "Components/FileUpload/FileUpload";

export const updateInscriptionLegalDocsConsent = async (
    inscriptionId: string,
    legalDocsConsent: string,
    legalDocsFiles: DropzoneFile[] = []
): Promise<unknown> => {
    if (legalDocsFiles.length === 0) {
        return await http.post(`inscriptions/${inscriptionId}/legal-docs-consent`, {
            legalDocsConsent: legalDocsConsent
        })
    }

    const data = new FormData()
    data.append('legalDocsConsent', legalDocsConsent)
    legalDocsFiles.forEach((dropzoneFile) => data.append('legalDocsFiles[]', dropzoneFile.file))

    return await http.post(`inscriptions/${inscriptionId}/legal-docs-consent`, data, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

export const addInscriptionObservation = async(
    inscriptionId: string,
    observation: string,
    sendMailToTutor: boolean = false
) => {
    return await http.post(`inscriptions/${inscriptionId}/observation`, {
        observation: observation,
        sendMailToTutor: sendMailToTutor
    })
}

export const updateInscription = async(inscriptionId:string, body: any) => {
    return await http.patch(`inscriptions/${inscriptionId}/admin`, {
        status: body.status,
        inscriptionOrderDiscountType: body.inscriptionOrderDiscountType,
        inscriptionOrderActivitiesToDelete: body.inscriptionOrderActivitiesToDelete,
        socialWorker: body.socialWorker ?? null,
        rejectedReason: body.rejectedReason ?? null
    })
}
